module.exports = __webpack_public_path__ + "static/media/book-dead.86776845.svg";